import { render, staticRenderFns } from "./setTagTableSet.vue?vue&type=template&id=0048b1ce&scoped=true"
import script from "./setTagTableSet.vue?vue&type=script&lang=js"
export * from "./setTagTableSet.vue?vue&type=script&lang=js"
import style0 from "./setTagTableSet.vue?vue&type=style&index=0&id=0048b1ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048b1ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0048b1ce')) {
      api.createRecord('0048b1ce', component.options)
    } else {
      api.reload('0048b1ce', component.options)
    }
    module.hot.accept("./setTagTableSet.vue?vue&type=template&id=0048b1ce&scoped=true", function () {
      api.rerender('0048b1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gridSelect/setTagTableSet.vue"
export default component.exports